/* eslint-disable import/no-cycle */
import { defineStore } from 'pinia';
import {
  IPhoto, IProfile, IProfileData, IResponse,
} from '@/types/interfaces';
import ProfileService from '@/modules/profile/services/ProfileService';
import isEmptyObject from '@/helpers/isEmptyObject';
import { useMainStore } from '@/store/mainStore';

export type ProfileState = {
  profile: IProfile,
  bufferProfile: IProfile,
  foreignProfile: IProfile,
}

export const useProfileStore = defineStore({
  id: 'profileStore',

  state: () => ({
    profile: {},
    foreignProfile: {},

    bufferProfile: {
      handle: '',
      bio: '',
      photo: {
        id: '',
        url: '',
      },
      speciality: null,
      workplaces: [
        {
          name: '',
          street: '',
          city: '',
          state: '',
          zipCode: null,
        },
      ],
      educations: [
        {
          school: '',
          degree: '',
          startDate: null,
          endDate: null,
        },
      ],
      email: '',
      phone: '',
      street: '',
      city: '',
      state: '',
      zipCode: null,
    },
  } as ProfileState),

  actions: {
    async fetchAndReturnProfile(): Promise<IProfile> {
      if (!isEmptyObject(this.profile)) {
        return new Promise((resolve) => resolve(this.profile as IProfile));
      }
      return ProfileService.fetchAndReturnProfile()
        .then((response: IResponse<IProfileData>) => {
          if (response.success) {
            this.updateProfileAndBuffer(response.results.data);
          }
          return this.profile as IProfile;
        });
    },

    async saveAndReturnProfile(): Promise<IProfile> {
      // const payloadNormalized = { ...this.bufferProfile };
      return ProfileService.saveAndReturnProfile(this.bufferProfile as IProfile)
        .then((response: IResponse<IProfileData>) => {
          if (response.success) {
            this.updateProfileAndBuffer(response.results.data);
          }
          return this.profile as IProfile;
        });
    },

    async getProfileById(id: string): Promise<IProfile> {
      return ProfileService.getProfileById(id)
        .then((response: IResponse<IProfileData>) => {
          if (response.success) {
            this.foreignProfile = { ...response.results.data, status: response.results.contactStatus };
            return this.foreignProfile as IProfile;
          }
          return Promise.reject(response);
        });
    },

    updateProfileAndBuffer(profile: IProfile): void {
      this.profile = Object.assign({} as IProfile, profile);
      this.bufferProfile = Object.assign({} as IProfile, profile);
    },

    updatePhoto(media: IPhoto): void {
      const mainStore = useMainStore();

      this.profile.photo = media;
      this.bufferProfile.photo = media;
      mainStore.user.photo = media;
    },

    resetBufferProfile(): void {
      this.bufferProfile = Object.assign({} as IProfile, this.profile);
    },
  },

});
